import React from 'react';
import { NavHeader } from './components';

function App() {
  ////const value = 'World';
  return (
    <div>
      <NavHeader />
    </div>);
}

export default App;
